export const environment = {
    ebizRootURL: 'https://epaproject1apps.epa.ohio.gov',
    clientID : '00752898-645b-4d6e-b3a8-804dd6a8ad85',
    redirectURI: 'https://dsw-401.project1.epa.ohio.gov',  
};
